import { ChipSelectable as UIChipSelectable } from "@webmotors/eleanor-ui";

export interface ChipSelectableProps
  extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  label: string;
  onClick?: (event?: React.MouseEvent<HTMLElement>) => void;
  showIcon?: boolean;
  size?: "small" | "medium";
  state?: "default" | "disabled" | "active";
  variant?: "outline" | "filled";
  dataQa?: string;
}

export function ChipSelectable({
  className,
  label,
  onClick,
  showIcon = true,
  size = "medium",
  state = "default",
  variant = "filled",
  ...props
}: Readonly<ChipSelectableProps>) {
  return (
    <UIChipSelectable
      className={className}
      label={label}
      onClick={onClick}
      showIcon={showIcon}
      size={size}
      state={state}
      variant={variant}
      {...props}
    />
  );
}
